module.exports = __webpack_public_path__ + "static/img/31.a5b89e8b.jpg";